var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultisigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_319_1489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#BAFD63"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_319_1489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.875 36.1H32.125L30.5438 27.3925C31.4604 26.9425 32.1823 26.29 32.7094 25.435C33.2365 24.58 33.5 23.635 33.5 22.6C33.5 21.115 32.9615 19.8438 31.8844 18.7863C30.8073 17.7288 29.5125 17.2 28 17.2C26.4875 17.2 25.1927 17.7288 24.1156 18.7863C23.0385 19.8438 22.5 21.115 22.5 22.6C22.5 23.635 22.7635 24.58 23.2906 25.435C23.8177 26.29 24.5396 26.9425 25.4563 27.3925L23.875 36.1ZM28 55C21.6292 53.425 16.3698 49.8363 12.2219 44.2338C8.07396 38.6313 6 32.41 6 25.57V9.1L28 1L50 9.1V25.57C50 32.41 47.926 38.6313 43.7781 44.2338C39.6302 49.8363 34.3708 53.425 28 55ZM28 49.33C32.7667 47.845 36.7083 44.875 39.825 40.42C42.9417 35.965 44.5 31.015 44.5 25.57V12.8125L28 6.7375L11.5 12.8125V25.57C11.5 31.015 13.0583 35.965 16.175 40.42C19.2917 44.875 23.2333 47.845 28 49.33Z",
    fill: "url(#paint0_linear_319_1489)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_1489",
    x1: 28,
    y1: 1,
    x2: 28,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultisigLogo);
export default __webpack_public_path__ + "static/media/multisig-logo.133a5114c386c8b67b65bdaf0b1b013d.svg";
export { ForwardRef as ReactComponent };